<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" class="vx-row">
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="isSubmitted && isReader">
        <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="viewRecord" v-b-tooltip.hover :title="$t('MRMR.Statement.View')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="!isSubmitted && isWriter">
        <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord" v-b-tooltip.hover :title="$t('MRMR.Statement.Edit')" />    
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="!isSubmitted && isWriter">
        <feather-icon  icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-b-tooltip.hover :title="$t('Delete')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="isSubmitted && isWriter">
        <feather-icon icon="CopyIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="duplicateStatement" v-b-tooltip.hover :title="$t('MRMR.Statement.Duplicate')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="isSubmitted && isApproved && (isWriter || isConsolidator)">
        <feather-icon icon="LogOutIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="renewStatement" v-b-tooltip.hover :title="$t('MRMR.Statement.Renew')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="!isSubmitted && isWriter">
        <feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openSubmissionConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.Submit')" />
      </div>

      <!-- Approval + Rejection by Geo Corpo -->
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="(isSubmitted && isConsolidator && (isApprovedByEngineering || !requiresEngineeringApproval)) || (isApproved && isConsolidator)" >
        <feather-icon  icon="XIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="rejectStatement" v-b-tooltip.hover :title="$t('MRMR.Statement.Reject')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="isSubmitted && !isApproved && isConsolidator && (isApprovedByEngineering || !requiresEngineeringApproval)" >
        <feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openApprovalConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.ApprovalShort')" />
      </div>

      <!-- Approval + Rejection by QP Engineering -->
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="qpEngineeringApprovalEnabled && isSubmitted && isQpEngineering && !isApprovedByEngineering && requiresEngineeringApproval && !isApproved" >
        <feather-icon  icon="XIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="rejectStatement" v-b-tooltip.hover :title="$t('MRMR.Statement.Reject')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="qpEngineeringApprovalEnabled && isSubmitted && isQpEngineering && !isApprovedByEngineering && requiresEngineeringApproval" >
        <feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openEngineeringApprovalConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.ApprovalShort')" />
      </div>

      <!-- cancel submission -->
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="isSubmitted && !isApprovedByEngineering && !isApproved && isWriter" >
        <feather-icon icon="XIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openCancelSubmissionConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.CancelSubmission')" />
      </div>
      <div class="vx-col sm:flex-row flex-col sm:w-1" v-if="wasSubmitted" >
        <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openSubmissionNotes" v-b-tooltip.hover :title="$t('MRMR.Statement.SubmissionNotes')" />
      </div>
    </div>
</template>

<script>
export default {
  name: 'StatementActionsCellRenderer',
  computed: {
    isSubmitted() {
      return this.params.data.isSubmitted;
    },
    wasSubmitted() {
      return this.params.data.isSubmitted || this.params.data.version > 1;
    },
    isApproved() {
      return this.params.data.isApproved;
    },
    isApprovedByEngineering() {
      return this.params.data.isApprovedByEngineering;
    },
    requiresEngineeringApproval() {
      return !this.isApproved && this.params.data.requiresEngineeringApproval;
    },
    isQpEngineering() {
      // make sure qpEngineering is not null
      return this.params.data.qpEngineering && this.params.data.qpEngineering.toLowerCase()  === this.$auth.getUser().username.toLowerCase();
    },
    isConsolidator() {
      return this.$auth.isInRole("MRMRConsolidation") || this.$auth.isInRole("Admin");
    },
    isWriter() {
      return this.$auth.isInRole("MRMRCollaborators") || this.$auth.isInRole("Admin");
    },
    isReader() {
      return this.$auth.isInRole("MRMRReaders") || this.$auth.isInRole("Admin");
    },
    qpEngineeringApprovalEnabled() {
      if (this.params.context && this.params.context.componentParent) {
        return this.params.context.componentParent.qpEngineeringApprovalEnabled;
      }
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },
    viewRecord () {
      this.params.context.componentParent.viewData(this.params.data);
    },

    openSubmissionConfirm() {
      if (this.params.data.notes === null || (this.params.data.notes === "")) {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t('MRMR.Statement.NoComment'),
          text: this.$t('MRMR.Statement.ConfirmNoComments'),
          accept: this.submitStatement
        })
      } else {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('Save'),
          text: this.$t('MRMR.Statement.ConfirmSubmission'),
          accept: this.submitStatement
        });
      }
    },

    openCancelSubmissionConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('MRMR.Statement.ConfirmCancelSubmission'),
        accept: this.cancelSubmission
      });
    },

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Delete"),
        text: this.$t('MRMR.Statement.ConfirmDelete'),
        accept: this.deleteRecord,
        acceptText: "Ok"
      });
    },

    openApprovalConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('MRMR.Statement.ConfirmApproval'),
        accept: this.approveStatement
      });
    },

    openEngineeringApprovalConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('MRMR.Statement.ConfirmApprovalByEngineering'),
        accept: this.approveStatementByEngineering
      });
    },
    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.id);
    },
    submitStatement () {
      this.params.context.componentParent.submitStatement(this.params.data.id);
    },
    cancelSubmission () {
      this.params.context.componentParent.cancelSubmission(this.params.data.id);
    },
    rejectStatement () {
      this.params.context.componentParent.openRejectPrompt(this.params.data.id);
    },
    approveStatement () {
      this.params.context.componentParent.approveStatement(this.params.data.id);
    },
    approveStatementByEngineering () {
      this.params.context.componentParent.approveStatementByEngineering(this.params.data.id);
    },    
    duplicateStatement () {
      this.params.context.componentParent.openDuplicatePrompt(this.params.data.id);
    },
    renewStatement () {
      this.params.context.componentParent.openRenewPrompt(this.params.data.id);
    },
    openSubmissionNotes() {
      this.params.context.componentParent.openSubmissionNotes(this.params.data.id);
    }
  }
}
</script>
<style>
  .ag-cell-value {
    overflow: visible;
  }
</style>